import PromotionalBannerContent from './PromotionalBannerContent';

export default PromotionalBannerContent;
